import React, { useState, useEffect } from "react";
import ReactJoyride from "react-joyride";

const TourComponent = ({
  run,
  steps,
  onStart,
  onComplete,
  stepScrollBottom,
  stepScrollTop,
}) => {
  const [completedSteps, setCompletedSteps] = useState([]);
  const [buttonText, setButtonText] = useState("Continue");

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    // Reset buttonText to "Continue" when the tour starts
    setButtonText("Continue");
  }, [run]);

  const handleJoyrideCallback = (data) => {
    const { action, index, status, type } = data;

    if (status === "ready" && onStart) {
      onStart();
    }

    if (status === "finished" && onComplete) {
      onComplete();
    }

    if (type === "step:after" && index < steps.length - 1) {
      // Not the last step
      setButtonText("Continue");
    } else if (index === steps.length - 1) {
      // Last step
      setButtonText("End Tour");
    }

    // Check scroll top
    if (
      (action === "next" || action === "start") &&
      stepScrollTop &&
      steps[index]?.target === stepScrollTop
    ) {
      setTimeout(() => {
        scrollToTop();
      }, 500);
    }

    // Check scroll bottom
    if (
      (action === "next" || action === "start") &&
      stepScrollBottom &&
      steps[index]?.target === stepScrollBottom
    ) {
      var element = document.querySelector(".scrollbar-container");
      if (element) {
        element.scrollTop = element.scrollHeight;
      }
    }
  };

  return (
    <ReactJoyride
      steps={steps}
      run={run}
      continuous={true}
      scrollToFirstStep={true}
      showProgress={false}
      showSkipButton={false}
      disableBeacon={true}
      disableOverlayClose={true}
      styles={{
        options: {
          zIndex: 10000,
          primaryColor: "#0000ff",
        },
        buttonNext: {
          backgroundColor: "#0078CF",
          color: "#ffffff",
          width: "100%",
          margin: "0 auto",
          padding: "12px",
        },
        tooltipFooter: {
          display: "flex",
          justifyContent: "center",
        },
        buttonBack: {
          display: "none",
        },
        buttonSkip: {
          display: "none",
        },
        buttonClose: {
          display: "none",
        },
        title: {
          color: "#687485",
        },
      }}
      locale={{ last: buttonText, next: buttonText }}
      callback={handleJoyrideCallback}
    />
  );
};

export default TourComponent;
